import * as React from "../../_snowpack/pkg/react.js";
const Rect = ({color}) => {
  const getClassName = () => `bg-${color}-400`;
  const fillClass = getClassName();
  return /* @__PURE__ */ React.createElement("div", {
    className: `h-10 w-8 mr-2 flex-shrink-0 ${fillClass}`
  });
};
export default Rect;
